<template>
  <RadioGroup v-if="![78, 210, 212].includes(getgameid)" v-model="radio">
    <Radio :label="1">生尾</Radio>
    <Radio :label="2">肖量</Radio>
  </RadioGroup>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      radio: 1,
      key: {
        1: { 
          path: "rawtail", 
          query: { page: "9", odd: "11", radio: 1 } 
        },
        2: { 
          path: "rawtail", 
          query: { page: "9", odd: "47", radio: 2 } 
        }
      }
    };
  },
  computed: {
    ...mapGetters(["getgameid"])
  },
  created () {
    if(this.$route.query.radio){
      this.radio = Number(this.$route.query.radio)
    }
  },
  watch: {
    radio(val) {
      this.$router.push(this.key[val]).catch(err => {});
      this.chg_liveshow_state({ proj: val });
    }
  },
  methods: {
    ...mapActions(["chg_liveshow_state"]),
  }
};
</script>